
(function () {
  /**
   * Default ajax setting
   */
  $.ajaxSetup({
    headers: {
      'X-CSRF-TOKEN': $("meta[name='csrf-token']").attr('content'),
    },
    dataType: "json"
  });

  /**
   * Returns true or false  This function will check @param is null or not 
   * @param {any} myVar This function will check @param is null or not 
   * @return {boolean}
  */
  isEmpty = function (myVar) {
    if (myVar == '' || myVar == 0 || myVar == null || myVar === undefined)
      return true;
    else
      return false;
  }

  isObjectEmpty = function (obj) {
    for(var prop in obj) {
      if(obj.hasOwnProperty(prop))
        return false;
    }
    return true;
  }

  toggleLoader = function () {
    if ($('#loaderScreen').hasClass('d-none'))
      showLoader(true);
    else
      showLoader(false);
  }

  showLoader = function (value) {
    if (value)
      $('#loaderScreen').removeClass('d-none')
    else
      $('#loaderScreen').addClass('d-none')
  }
  


  /**
   * Default vaidation options
   */
  $.validator.setDefaults({
    highlight: function (element) {
      $(element).closest('fieldset').addClass("has-error");
    },
    unhighlight: function (element) {
      $(element).closest('fieldset').removeClass("has-error");

      $(element).siblings('.field-error').text('');
    },
    errorPlacement: function (error, element) {
      if (element.hasClass("phone-iti")) {
        $(element).parent().siblings('.field-error').text(error.text());
      } else {
        $(element).siblings('.field-error').text(error.text());
      }      
    },
    messages: {
      'email': {
        'required': 'email required',
        'email': 'valid email required',
      },
      'mobile': {
        'required': 'mobile number required',
        'minlength': '(value must be between 5 and 30 digits)',
        'maxlength': '(value must be between 5 and 30 digits)',
      }
    }
  });

})();